import { render } from "./associateBloc.vue?vue&type=template&id=68151637&scoped=true"
import script from "./associateBloc.vue?vue&type=script&lang=js"
export * from "./associateBloc.vue?vue&type=script&lang=js"

import "./associateBloc.vue?vue&type=style&index=0&id=68151637&lang=scss&scoped=true"

import exportComponent from "/usr/src/oho-accounting-test/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68151637"]])

export default __exports__